export const commafy = (
	val: string | number,
	countryIso?: string,
): string | null => {
	if (val === null || val === undefined) return null;

	const num =
		typeof val === "string" && !isNaN(Number(val))
			? Number(val)
			: typeof val === "number"
				? val
				: null;

	if (num === null) return null;

	const normalizedIso = countryIso?.toUpperCase();

	let locale = "en-US";
	let currency = "USD";

	if (normalizedIso === "IN" || normalizedIso === "IND") {
		locale = "en-IN";
		currency = "INR";
	} else if (normalizedIso === "US" || normalizedIso === "USA") {
		locale = "en-US";
		currency = "USD";
	}

	return new Intl.NumberFormat(locale, {
		style: "currency",
		currency,
		maximumFractionDigits: 2,
	}).format(num);
};

export const commafySymbol = (countryIso?: string): string => {
	const normalizedIso = countryIso?.toUpperCase();

	let locale = "en-US";
	let currency = "USD";

	if (normalizedIso === "IN" || normalizedIso === "IND") {
		locale = "en-IN";
		currency = "INR";
	} else if (normalizedIso === "US" || normalizedIso === "USA") {
		locale = "en-US";
		currency = "USD";
	}

	const parts = new Intl.NumberFormat(locale, {
		style: "currency",
		currency,
		currencyDisplay: "narrowSymbol",
	}).formatToParts(0);

	const symbolPart = parts.find((p) => p.type === "currency");
	return symbolPart?.value ?? "$";
};
